<script>
import {getParameters} from '../../../../frontend-templates/resources/js/vue-flows/helpers/history/v1/history-1.0.0.js';

export default {
  methods: {
    fillUrlVariables() {
      const variables = getParameters();

      for(const [key, value] of Object.entries(variables)) {
        if (!value) continue;
        this.$store.commit('page/setVariable', { key, value: decodeURIComponent(value.replace(/\+/g, ' ')) });
      }
    },
  },
};
</script>
